
import { Box, Button, Grid, Typography } from '@mui/material';
import { Formik, Form } from 'formik';
import React, { useEffect, useState } from 'react';
import CustomPdfUpload from '../../../../Components/CustomPdfUpload/CustomPdfUpload';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import actions from '../../../../ReduxStore/actions';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import * as Yup from 'yup';
import InvalidRowsModal from '../../../../Components/InvalidRowsModal/InvalidRowsModal';
import CustomTable from '../../../../Components/Table/CustomTable';
import UploadedFilesDialog from './UploadedFilesDialog ';

const validationSchema = Yup.object().shape({
    filterByYear: Yup.string().required('Year is required'),
    //   files: Yup.array()
    //     .of(Yup.mixed()) // Can specify file type/size later if needed
    //     .min(1, 'At least one file must be uploaded')
});


const EmployeePdfUpload = () => {
    const dispatch = useDispatch();
    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }

    useEffect(() => {
        dispatch(setHeaderName("Employee PDF Upload"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesss")
        if (values?.filterByYear && values?.files?.length === 0) {

            toast.error("At least one file must be uploaded")
            return


        }
        setLoading(true)
        if (values?.files?.length > 0) {
            const formData = new FormData();

            // Append the year directly
            formData.append("appraisal_year", values?.filterByYear);

            values?.files?.forEach(file => {
                formData.append("uploadPdfs", file); // ensure backend expects 'files'
            });

            const data1 = {
                data: formData,
                method: "post",
                apiName: "uploadMultiplePdfs"
            };

            const responseData = await dispatch(actions.UPLOADMULTIPLEPDFS(data1));

            if (responseData?.payload?.message === "PDF upload completed with validations.") {
                setLoading(false)
                toast.success("Bulk upload successful.");


                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen()
                resetForm();
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message);
            }
        } else {
            setLoading(false)
            toast.error("Please upload at least one PDF file.");
        }
    };



    const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
    console.log(getAllAppraisalYears, "getAllAppraisalYears")

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllAppraisalYears"
            };
            const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [])

    const yearOptions = getAllAppraisalYears?.data?.map((data, index) => ({

        // id: data?.internship_id,
        value: data?.appraisal_year,
        label: data?.appraisal_year
    }));

    const tableHeadData = ["S.No", "Appraisal Year", "Actions"];
    const [rowTableData, setRowTableData] = useState([])

    useEffect(() => {

        const tempArr = [];

        getAllAppraisalYears?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.appraisal_year_id,
                appraisal_year: data?.appraisal_year
            });
        });
        setRowTableData(tempArr);




    }, [getAllAppraisalYears])

    const [editData, setEditData] = useState()
    const [selectedYear, setSelectedYear] = useState()




    const { getAppraisalYearById } = useSelector((state) => state?.getAppraisalYearById);


    const handleTableEdit = async (id) => {
        // setShowExcelUpload(false)
        // setLoading(true)
        setSelectedYear(id)
        // console.log(id, "idgretoriut")
        // const data1 = {
        //     data: {},
        //     method: "get",
        //     apiName: `getPdfsByAppraisalYear?appraisal_year=${id}`
        // };
        // const responseData = await dispatch(actions.GETPDFSBYAPPRAISALYEAR(data1));
        // console.log(responseData, "getAppraisalYearById")

        // const message = responseData?.payload?.message;

        // const pattern = /^Found\s+\d+\s+PDF\(s\)\s+under\s+appraisal_year\s+'(\d{4}-\d{2})'\.?$/;

        // if (pattern.test(message)) {
        //     const match = message.match(pattern);
        //     console.log(match, "matchhhh")
        //     const appraisalYear = match[1]; // e.g., "2029-30"
        //     console.log("✅ Valid message with appraisal year:", appraisalYear);

        // } else {
        //     console.log("❌ Invalid message format.");
        // }
        // const match = message.match(pattern);


        // if (responseData?.payload?.message === match[0]) {
        //     setLoading(false)
        //     setEditData(responseData?.payload?.data)
        //     const files = responseData?.payload?.data || [];
        //     setUploadedFiles(files);
            setOpenDialog(true);
        // }



    }
    return (
        <Box>
            <Box sx={{ background: "white", p: 3, mb: 2 }}>
                {loading && <FullPageLoader />}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        Upload  Appraisal PDF
                    </Typography>
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        filterByYear: "",
                        files: []
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, resetForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 12 }}>

                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <CustomDropdownMui
                                            name="filterByYear"
                                            label="Year of Appraisal"
                                            custPlaceholder="--Select a Year--"
                                            // disabled
                                            options={yearOptions}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Typography variant="subtitle1" sx={{
                                            color: "gray",

                                            fontSize: "15px",
                                            mb: 1
                                        }}>

                                            Upload PDF <span style={{ fontSize: "12px" }}>(Limit: 500 per time)</span>
                                        </Typography>
                                        <CustomPdfUpload
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            resetForm={resetForm}
                                        />

                                        {/* <Typography
                                    variant="body1"
                                    sx={{
                                        cursor: "pointer",
                                        color: "var(--main-color)",
                                        mt: 1
                                    }}
                                >
                                    Download & Sample Excel Format
                                </Typography> */}
                                    </Grid>
                                </Grid>

                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        disabled={isSubmitting}
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
                <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
                <InvalidRowsModal name="updateAppraisalPdfUpload" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />

            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Appraisal PDF's List"
                            tableEdit={false}
                            tableActions={true}
                            tableSearch={true}
                            tableGeByAppraisalYear={true}
                            handleTableEdit={handleTableEdit}


                        />
                        <UploadedFilesDialog
                            open={openDialog}
                            onClose={() => setOpenDialog(false)}
                            files={uploadedFiles}
                            
                            selectedYear={selectedYear}
                        // onDownload={handleDownload}
                        // onRemove={handleRemoveFile}
                        />

                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default EmployeePdfUpload;
